export default defineNuxtPlugin((nuxtApp) => {
    const imageUrl = useRuntimeConfig().public.imageUrl;

    nuxtApp.provide('uploadUrl', imageUrl);
    nuxtApp.provide('discountPrecentDefault', 1);
    nuxtApp.provide('discountPrecentAdditional', 1);
});